<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <contact-info>
        </contact-info> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import ContactInfo from './todo-contact-info'
export default {
    components: {
        ContactInfo
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-contact-info/base-contact-info.vue